import axios from "axios"
import qs from "query-string"
import type { AxiosParams } from "./AxiosParams"
import { urlMap } from "./urlMap"

export const getAxiosInstance = async (params: AxiosParams) => {
	const { config, dealershipId, environment, getAuthorizationHeader, locale, marketplaceKey } = params
	const Authorization = await extractHeader(getAuthorizationHeader)
	return axios.create({
		baseURL: urlMap[environment ?? "local"],
		paramsSerializer: {
			serialize: (p) => qs.stringify(p, { arrayFormat: "index" }),
		},
		...config,
		headers: {
			...config?.headers,
			accept: "application/json",
			"accept-language": locale,
			Authorization,
			"Content-Type": "application/json",
			"dealership-id": dealershipId,
			"marketplace-key": marketplaceKey,
		},
	})
}

const extractHeader = async (
	getAuthorizationHeaderFunction: AxiosParams["getAuthorizationHeader"],
): Promise<string | undefined> => {
	if (!getAuthorizationHeaderFunction) {
		return undefined
	}
	try {
		return (await getAuthorizationHeaderFunction()).Authorization
	} catch {
		return undefined
	}
}
